import { IVoucher } from './types';

export const voucherInitialState: IVoucher = {
  status: ''
};
